/* eslint-disable linebreak-style */
import { fetchExcludedMakes } from '../fetchers';
import { fetchWithCache } from '.';

export default async function filterOutExcludedMakes(isSeoMakeATC, makeList) {
    const s3Response = await fetchWithCache(
        fetchExcludedMakes,
        null,
        's3-exclude-makes',
        3600000 // 1 hour
    );

    const excludedMakesFromFdpqS3 = s3Response?.makes?.map((excludedMake) => excludedMake.toLowerCase());

    if (isSeoMakeATC) {
        return makeList.filter((make) => !excludedMakesFromFdpqS3?.includes(make.name?.toLowerCase()));
    }
    return makeList.filter((make) => !excludedMakesFromFdpqS3?.includes(make.makeName?.toLowerCase()));
}
